import { PATH } from '@/constants/index'
import { getCookie } from '@/utils'
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

export function useAuthenticated() {
  const route = useRoute()
  const authenticated = ref<boolean>(false)
  const required2FA = ref<boolean>(true)

  watch(
    () => route.path,
    () => {
      const path = PATH[`${route.path.split('/')[1]}`]
      authenticated.value = getCookie(path?.header) ? true : false
      required2FA.value = getCookie(`${path?.path}-required-two-factor`) === 'true'
    },
    { immediate: true, deep: true }
  )

  return { authenticated, required2FA }
}
